import { AuthService, LoginRequiredDialogService } from '@aipb/auth';
import { PersonalContentPermissionService } from '@aipb/personal-content/shared/auth';
import { SnackbarService } from '@aipb/ui/snackbar';
import { CONFIG_PERSONAL_CONTENT_ENABLED } from '@aipb/util/di';

import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'fr-personal-content-plugin-button',
  imports: [MatButtonModule, MatIconModule, TranslocoModule],
  templateUrl: './personal-content-plugin-button.component.html',
  styleUrls: ['./personal-content-plugin-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalContentPluginButtonComponent {
  @Output() action = new EventEmitter();

  private auth = inject(AuthService);
  private personalContentPermission = inject(PersonalContentPermissionService);
  private loginRequiredDialogService = inject(LoginRequiredDialogService);
  private snackbar = inject(SnackbarService);
  private personalContentEnabled = inject(CONFIG_PERSONAL_CONTENT_ENABLED);
  private transloco = inject(TranslocoService);

  get canUseFeature() {
    return this.personalContentPermission.canUsePersonalContent || this.personalContentEnabled;
  }

  get canAddToFavorites() {
    return (
      this.auth.isLoggedIn() && this.personalContentPermission.canUsePersonalContent && this.personalContentEnabled
    );
  }

  onAction() {
    if (!this.auth.isLoggedIn() && this.canUseFeature) {
      this.loginRequiredDialogService.open();
      return;
    }

    if (!this.canAddToFavorites) {
      this.snackbar.open(this.transloco.translate('personal_content.messages.feature_not_enabled'), 'info', {
        duration: 5000
      });
      return;
    }

    this.action.emit();
  }
}
